import { Component, inject, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AllTestResults, GiftResult, Person, SpiritualGiftScore } from '../services/spiritual-gifts/spiritual-gifts.service';
import { FirebaseService } from '../services/firebase/firebase.service';
import { instanceToPlain } from 'class-transformer';


@Component({
  selector: 'app-results-modal',
  standalone: true,
  imports: [CommonModule, IonicModule],
  templateUrl: './results-modal.component.html',
  styleUrls: ['./results-modal.component.scss'],
})
export class ResultsModalComponent implements OnInit {

  private modalCtrl = inject(ModalController);
  private firebaseService = inject(FirebaseService);

  @Input() person: Person = null;
  @Input() results: GiftResult[] = [];
  @Input() categories: SpiritualGiftScore[] = [];
  @Input() showCategories: boolean = false;
  @Input() showTotals: boolean = false;
  @Input() allResults: AllTestResults;

  thanksMessage = `<h3>Thank you for taking the Spiritual Gifts Test!</h3>
<p>We're so glad you took the time to discover your spiritual gifts.
God has uniquely equipped you to serve and make a difference in His work.
Use these results to grow, serve, and glorify Him at Lancaster Baptist Church.</p>

<p><strong>Your results have been saved and are listed below.</strong></p>`;

  constructor() {}

  async ngOnInit() {
    await new Promise(resolve => setTimeout(resolve, 1000));
    this.saveResults();
  }

  saveResults() {
    const id = `${this.person.Email}_${Math.ceil(Math.random() * 100000)}`;
    const resultsObject = instanceToPlain(this.allResults);
    this.firebaseService.setDocument(resultsObject, id);
  }

  closeModal(role: string = 'submit') {
    this.modalCtrl.dismiss(null, role, 'showResults');
  }
}
